export const customSelectStyles = {
    control: () => ({
        display: "flex"
    }),
    valueContainer: (provided) => ({
        ...provided,
        flex: "none",
        paddingLeft: 0,
        paddingRight: 0,
        cursor: "pointer"
    }),
    indicatorSeparator: () => ({
        display: "none"
    }),
    singleValue: () => ({
        fontSize: 15,
        color: "#f95936",
        fontWeight: 600
    }),
    dropdownIndicator: () => ({
        color: "#f95936",
        cursor: "pointer"
    }),
    menu: (provided) => ({
        ...provided,
        paddingTop: 5,
        paddingBottom: 5,
        minWidth: 110,
        borderRadius: 9,
        boxShadow: "0px 2px 8px #d9d9f0"
    }),
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? "#FFF" : "#2E3345",
        cursor: "pointer"
    })
}
